/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Mobile_Network_Inspector_Request_CountInputs */

const en_mobile_network_inspector_request_count = /** @type {(inputs: Mobile_Network_Inspector_Request_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} requests captured`)
};

const es_mobile_network_inspector_request_count = /** @type {(inputs: Mobile_Network_Inspector_Request_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} solicitudes capturadas`)
};

/**
* | output |
* | --- |
* | "{count} requests captured" |
*
* @param {Mobile_Network_Inspector_Request_CountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_network_inspector_request_count = /** @type {((inputs: Mobile_Network_Inspector_Request_CountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Network_Inspector_Request_CountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_network_inspector_request_count(inputs)
	return en_mobile_network_inspector_request_count(inputs)
});